module.exports = __webpack_public_path__ + "static/c3-e77558e0f2f33c4e10e3a0135303cf1c.png";